"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _CodeConsts = require("../../../constants/CodeConsts");
var _labelConsts = require("../../../constants/labelConsts");
var _stringUtil = _interopRequireDefault(require("../../../logics/stringUtil"));
var _LabelValueDisplay = _interopRequireDefault(require("../../layout/LabelValueDisplay"));
var _CLabel = _interopRequireDefault(require("../../materials/CLabel"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * アップロード対象／削除対象部品
 */
const TargetParts = props => {
  const {
    intl,
    title,
    siteKindCd,
    trainingName,
    implementationPeriod,
    kaishaSoshikiNm,
    bcpTgtJigyoNm,
    documentKindNm
  } = props;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: title
  })), siteKindCd === _CodeConsts.CODE.SITE_KIND_CD.CODE_KR && /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_TRAINING_NAME
    }),
    value: _stringUtil.default.emptyToHyphen(trainingName),
    labelWidth: 200
  })), siteKindCd === _CodeConsts.CODE.SITE_KIND_CD.CODE_RH && /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_IMPLEMENTATION_PERIOD
    }),
    value: _stringUtil.default.emptyToHyphen(implementationPeriod),
    labelWidth: 200
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_KAISHA_SOSHIKI
    }),
    value: _stringUtil.default.emptyToHyphen(kaishaSoshikiNm),
    labelWidth: 200
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_BCP_TGT_JIGYO
    }),
    value: _stringUtil.default.emptyToHyphen(bcpTgtJigyoNm),
    labelWidth: 200
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_TARGET_DOCUMENT
    }),
    value: _stringUtil.default.emptyToHyphen(documentKindNm),
    labelWidth: 200
  })));
};
TargetParts.propTypes = {
  title: _propTypes.default.string.isRequired,
  siteKindCd: _propTypes.default.string.isRequired,
  trainingName: _propTypes.default.string,
  implementationPeriod: _propTypes.default.string,
  kaishaSoshikiNm: _propTypes.default.string,
  bcpTgtJigyoNm: _propTypes.default.string,
  documentKindNm: _propTypes.default.string
};
var _default = exports.default = (0, _reactIntl.injectIntl)(TargetParts);